<template>
  <div class="upload-wrapper">
    <div class="text-center" id="custom-file">
      <input @change="getFile" class="custom-file-input" type="file" v-bind:id="id" v-bind:name="name"/>
      <label class="btn btn-primary" v-bind:for="id">{{ label }}</label>
      <div class="invalid-feedback d-block">{{ error }}</div>
    </div>
    <template v-if="file.file">
      <div :key="file.id" class="row " v-bind:id="file.id">
        <div class="col-2 col-md-1">
          <v-icon color="red">fiber_new</v-icon>
        </div>
        <div class="col-10 col-md-5">
          <div class="text" v-if="file.success">
            <a target="_blank" v-bind:href="getDownloadUrl(file.response.id)">
              {{ file.name }}
            </a>
          </div>
          <div v-else>{{ file.name }}</div>

          <div class="progress" v-if="file.active || file.progress !== '0.00'">
            <div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"
                 :style="{width: file.progress + '%'}" role="progressbar">{{ file.progress }}%
            </div>
          </div>
        </div>

        <div class="col-3 d-md-none"></div>
        <div class="col-6 col-md-3 pt-1 text text-center" v-if="file.error">アップロード失敗</div>
        <div class="col-6 col-md-3 pt-1 text text-center" v-else-if="file.success">アップロード完了</div>
        <div class="col-6 col-md-3 pt-1 text text-center" v-else-if="file.active">アップロード中</div>
        <div class="col-6 col-md-3 pt-1 text text-center" v-else></div>

        <div class="col-3 pt-1 text-center">
          <button-confirm
              :func-ok="function() { deleteFile() }"
              classes="btn-danger"
              label="削除"
              message="本当に削除してよろしいですか？"
              title="データを削除しようとしています"
              v-if="file.success"
          >
          </button-confirm>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import {BrowserImageCompressionMixin} from "./../../mixins/browserImageCompression";


export default {
  components: {
    FileUpload,
  },
  mixins: [
    BrowserImageCompressionMixin
  ],
  props: {
    label: String,
    id: String,
    name: String,
    front_flg: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      file: this.getDefaultFile(),
      tempFile: null,
      url_store: "/admin/api/commons/file/upload",
      url_destroy: "/admin/api/commons/file/delete/",
      url_download: "/admin/commons/file/downloadTemporary/",
      error: null,
    }
  },
  created() {
    if (this.front_flg) {
      this.url_store = "api/commons/file/upload";
      this.url_destroy = "api/commons/file/delete";
      this.url_download = "commons/file/downloadTemporary/";
    }
    this.init();
  },
  methods: {
    init() {
      this.$set(this, 'file', this.getDefaultFile());
    },
    getDefaultFile() {
      this.$emit('failed');
      return {
        'file': null,
        'name': null,
        'active': false,
        'success': false,
        'error': false,
        'response': null,
        'progress': 0,
      };
    },
    getFile(e) {
      //既存ファイルを削除する
      this.deleteFile();

      // ファイルを取得する
      const files = e.target.files || e.dataTransfer.files;

      // ファイルが選択されなかった場合は終了
      if (!files) {
        this.$set(this, 'file', this.getDefaultFile());
        return;
      }

      // ファイルを取得する
      let file = files[0];

      // アップロードファイルの圧縮
      if (BrowserImageCompressionMixin.canCompressImage(file)) {
        let _this = this;
        let seqId = this.$root.startApiRequest();
        BrowserImageCompressionMixin.getCompressImageFileAsync(file).then(function (blob) {
          let tempFile = new File([blob], blob.name, {type: blob.type});
          _this.$root.endApiRequest(seqId);
          _this.upload(tempFile);
        });
      } else {
        this.upload(file);
      }
    },
    upload(file) {
      // ファイル情報を取得
      this.$set(this.file, 'file', file);
      this.$set(this.file, 'name', file.name);

      //アップロード
      this.$set(this.file, 'active', true);
      let param = new FormData();
      param.append('file', this.file.file);
      let seqId = this.$root.startApiRequest();
      appUtil.postAction(this.url_store, param, {onUploadProgress: this.onUpload})
          .then(response => {
            this.$set(this.file, 'response', response.data);
            this.$set(this.file, 'success', true);
            this.$emit('success');
          })
          .catch(response => {
            this.$set(this.file, 'error', true);
            this.$emit('failed');
            let message = 'アップロードに失敗しました';
            if (response.response.data.errors) {
              if (response.response.data.errors.file) {
                message = response.response.data.errors.file[0];
              } else if (response.response.data.errors.application) {
                message = response.response.data.errors.application[0];
              }
            }
            appUtil.showErrorDialog('アップロードエラー', message);
          })
          .finally(() => {
            this.$root.endApiRequest(seqId);
            this.$set(this.file, 'active', false);
          });
    },
    getDownloadUrl(id) {
      return this.url_download + id;
    },
    onUpload(e) {
      // プログレスバーを計算して変更
      this.$set(this.file, 'progress', Math.floor((e.loaded * 100) / e.total));
    },
    deleteFile() {
      if (this.file.success) {
        if (this.front_flg) {
          // スマホだとDELETEアクションが利用できない場合があるのでPOSTアクションで対応する
          let param = {
            'file': {
              'id': this.file.response.id
            }
          };
          let seqId = this.$root.startApiRequest();
          appUtil.postAction(this.url_destroy, param)
              .then(response => {
                this.$set(this, 'file', this.getDefaultFile());
              })
              .catch(response => {
                appUtil.showErrorDialog('ファイル削除エラー', 'ファイルの削除に失敗しました。');
              })
              .finally(() => {
                this.$root.endApiRequest(seqId);
                this.$set(this, 'file', this.getDefaultFile());
              });
        } else {
          let url = this.url_destroy + this.file.response.id;
          let seqId = this.$root.startApiRequest();
          appUtil.deleteAction(url)
              .then(response => {
                this.$set(this, 'file', this.getDefaultFile());
              })
              .catch(response => {
                appUtil.showErrorDialog('ファイル削除エラー', 'ファイルの削除に失敗しました。');
              })
              .finally(() => {
                this.$root.endApiRequest(seqId);
                this.$set(this, 'file', this.getDefaultFile());
              });
        }
      } else {
        this.$set(this, 'file', this.getDefaultFile());
      }
    }
  },
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}

label {
  padding: 10px 50px;
  display: inline-block;
  position: relative;
  will-change: box-shadow;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
}

.text {
  font-size: 12px;
}
</style>